import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService } from "../authentication.service";
import { User } from "../auth.interfaces";
import { redirectTo, showToastr } from "@shared/common";
import { environment } from "@env/environment";
import { ToastrService } from "ngx-toastr";

@Component({
  templateUrl: "login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  infoVisible = false;
  userName: string;
  password: string;
  env = environment;

  constructor(
    private router: Router,
    private service: AuthenticationService,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.userName = params["Rnc"];
      this.infoVisible = params["infoVisible"];
    });
  }

  login() {
    this.service.login(this.userName, this.password).subscribe((user: User) => {
      try {
        this.router.navigate([redirectTo(user)]);
      } catch (error) {
        showToastr(this.toastr, error, "error");

        setTimeout(() => {
          this.service.signout();
        }, 500);
      }
    });
  }
}
